import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Home, LayoutGrid, ShoppingBag, Store, Percent } from 'lucide-react';
import { selectCartTotalQuantity, toggleCart } from '../store/slices/cartSlice';
import { clearFilters } from '../store/slices/filtersSlice';
import CategoryDrawer from './CategoryDrawer';

const MobileBottomNav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const totalQuantity = useSelector(selectCartTotalQuantity);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const goHome = () => {
    dispatch(clearFilters());
    navigate('/');
  };

  const tabClass = (active) =>
    `flex flex-col items-center justify-center gap-0.5 text-xs font-medium transition-colors ${
      active ? 'text-primary-600' : 'text-gray-500 hover:text-primary-600'
    }`;

  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 pb-[env(safe-area-inset-bottom)]">
        <div className="grid grid-cols-5 h-16">
          <button onClick={goHome} className={tabClass(location.pathname === '/')}>
            <Home className="w-5 h-5" />
            Home
          </button>

          <button onClick={() => setDrawerOpen(true)} className={tabClass(false)}>
            <LayoutGrid className="w-5 h-5" />
            Category
          </button>

          <button
            onClick={() => navigate('/discounts')}
            className={`flex flex-col items-center justify-center gap-0.5 text-xs font-medium transition-colors ${
              location.pathname === '/discounts' ? 'text-red-600' : 'text-red-500 hover:text-red-600'
            }`}
          >
            <Percent className="w-5 h-5" />
            Discount
          </button>

          <button onClick={() => dispatch(toggleCart())} className={tabClass(false)}>
            <span className="relative">
              <ShoppingBag className="w-5 h-5" />
              {totalQuantity > 0 && (
                <span className="absolute -top-1.5 -right-2 bg-primary-600 text-white text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-0.5 leading-none">
                  {totalQuantity > 99 ? '99+' : totalQuantity}
                </span>
              )}
            </span>
            Cart
          </button>

          <button onClick={() => navigate('/products')} className={tabClass(location.pathname === '/products')}>
            <Store className="w-5 h-5" />
            Shop
          </button>
        </div>
      </nav>

      <CategoryDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export default MobileBottomNav;
